import { useState } from "react";

import { useTheme } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

type FilterDatePickerTextFieldParams = {
  filters: { [key: string]: any };
  setFilters: (_filter: { key: any; value: any }) => void;
  filterKey: string;
  [rest: string]: any;
};

const FilterDatePickerTextField = ({ filters, setFilters, filterKey, ...rest }: FilterDatePickerTextFieldParams) => {
  const theme = useTheme();

  const [isFocused, setIsFocused] = useState(false);

  return (
    <DatePicker
      onChange={(newDate) => {
        setFilters({
          key: filterKey,
          value: newDate,
        });
      }}
      {...rest}
      slotProps={{
        ...rest?.slotProps,
        textField: {
          ...rest?.slotProps?.textField,
          onBlur: () => {
            setIsFocused(false);
          },
          onFocus: () => {
            setIsFocused(true);
          },
          sx: [
            {
              "& .MuiInputBase-root": {
                height: "100%",
              },
              input: {
                py: 0.25,
              },
              ".MuiPickersSectionList-root": {
                p: 0.6,
              },
              button: {
                padding: 0.25,
              },
              ".MuiFormHelperText-root": {
                mt: 0,
              },
            },
            !isFocused &&
              !filters[filterKey] && {
                label: {
                  transform: `translate(${theme.spacing(1.5)}, ${theme.spacing(0.6)})`,
                },
              },
            { ...rest.sx },
          ],
        },
      }}
    />
  );
};

export default FilterDatePickerTextField;
